import './qcasino/style';
import FormStructure from './qcasino/form_structure';

export default FormStructure;